import { CurrentTermsType } from "api/types";
import Button from "components/common/Button/Button";
import Divider from "components/common/Divider";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import React, { FunctionComponent, SyntheticEvent, useState } from "react";
import { Col, Row } from "react-grid-system";
import theme from "themes/simple-theme-vh";
import {
  Link,
  TermsAndConditionsButton,
  TermsAndConditionsCheckbox,
  TermsAndConditionsContainer,
  TermsAndConditionsText
} from "./TermsAndConditions.style";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

interface IProps {
  tenantId: string;
  locationName: string;
  nextStep();
  previousStep();
}

const TermsAndConditionsVerde: FunctionComponent<IProps> = ({
  tenantId,
  locationName,
  previousStep,
  nextStep
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentTermsType, setCurrentTermsType] = useState();
  const [hasAgreedTcpa, setHasAgreedTcpa] = useState(false);
  const [hasAgreedPrivacy, setHasAgreedPrivacy] = useState(false);
  const [hasAgreedInfo, setHasAgreedInfo] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleHasAgreedTcpa = () => setHasAgreedTcpa(!hasAgreedTcpa);
  const handleHasAgreedPrivacy = () => setHasAgreedPrivacy(!hasAgreedPrivacy);
  const handleHasAgreedInfo = () => setHasAgreedInfo(!hasAgreedInfo);

  const handlePreviousStep = () => {
    setModalIsOpen(false);
    setHasAgreedTcpa(false);
    setHasAgreedPrivacy(false);
    setHasAgreedInfo(false);
    previousStep();
  };

  const handleCloseModal = () => setModalIsOpen(false);

  const handlePrivacyPolicyModal = (event: SyntheticEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    if (modalIsOpen) {
      return;
    }
    setModalIsOpen(true);
    setCurrentTermsType(CurrentTermsType.PrivacyPolicy);
  };

  const handleTermsAndConditionsModal = (
    event: SyntheticEvent<HTMLSpanElement>
  ) => {
    event.stopPropagation();
    if (modalIsOpen) {
      return;
    }
    setModalIsOpen(true);
    setCurrentTermsType(CurrentTermsType.TermsAndConditions);
  };

  const handleNextClick = callback => () => {
    setLoading(true);
    callback();
  };

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Terms and conditions"
      centerContent
    >
      <>
        <TermsAndConditionsContainer>
          <Row align="center">
            <Col>
              {tenantId === "a0e82b00-4dec-4176-9ff2-dd148972536b" && (
                <TermsAndConditionsCheckbox
                  white
                  labelFontSize={theme.fontSize.s}
                  checked={hasAgreedPrivacy}
                  onClick={handleHasAgreedPrivacy}
                  label={
                    <span>
                      By checking the box and signing up, you consent to receive
                      informational and marketing text messages from or on
                      behalf of us/Eugreen Health Center/Verde—including texts
                      sent using an autodialer—to the wireless number you
                      provided above. Your consent is not required to make a
                      purchase. You also agree to receive promotional emails.
                    </span>
                  }
                />
              )}
              {tenantId !== "a0e82b00-4dec-4176-9ff2-dd148972536b" && (
                <TermsAndConditionsCheckbox
                  white
                  labelFontSize={theme.fontSize.s}
                  checked={hasAgreedPrivacy}
                  onClick={handleHasAgreedPrivacy}
                  label={
                    <span>
                      By checking the box and signing up, you consent to receive
                      informational and marketing text messages from or on
                      behalf of us/Eugreen Health Center/Verde—including texts
                      sent using an autodialer—to the wireless number you
                      provided above. Your consent is not required to make a
                      purchase. You also agree to receive promotional emails.
                    </span>
                  }
                />
              )}
              <Divider transparent />
              <TermsAndConditionsCheckbox
                white
                labelFontSize={theme.fontSize.s}
                checked={hasAgreedTcpa}
                onClick={handleHasAgreedTcpa}
                label={
                  <span>
                    By checking the box and signing up, you agree to the{" "}
                    <Link onClick={handlePrivacyPolicyModal}>
                      Privacy Policy
                    </Link>{" "}
                    and{" "}
                    <Link onClick={handleTermsAndConditionsModal}>
                      Terms of Use
                    </Link>{" "}
                    —which include an Arbitration Agreement and Class Action
                    Waiver.
                  </span>
                }
              />
              <Divider transparent />
              {tenantId === "a0e82b00-4dec-4176-9ff2-dd148972536b" && (
                <TermsAndConditionsCheckbox
                  white
                  labelFontSize={theme.fontSize.s}
                  checked={hasAgreedInfo}
                  onClick={handleHasAgreedInfo}
                  label={
                    <span>
                      By providing your information and signing up, you also
                      consent that your information may be recorded and retained
                      and used by us/Eugreen Health Center/Verde for such
                      marketing purposes. Additionally, you confirm that you are
                      providing your own contact information (and not that of
                      another individual) and that you are at least 21 years or
                      older.
                    </span>
                  }
                />
              )}
              {tenantId !== "a0e82b00-4dec-4176-9ff2-dd148972536b" && (
                <TermsAndConditionsCheckbox
                  white
                  labelFontSize={theme.fontSize.s}
                  checked={hasAgreedInfo}
                  onClick={handleHasAgreedInfo}
                  label={
                    <span>
                      By providing your information and signing up, you also
                      consent that your information may be recorded and retained
                      and used by us/VVR Enterprises, LLC/Verde for such
                      marketing purposes and may be retained beyond the 60 days
                      permitted under Oklahoma law. Additionally, you confirm
                      that you are providing your own contact information (and
                      not that of another individual) and that you are at least
                      21 years or older.
                    </span>
                  }
                />
              )}
              <TermsAndConditionsText style={{ textAlign: "center" }}>
                You may opt-out of texts any time by replying STOP.
              </TermsAndConditionsText>
            </Col>
          </Row>
          <Divider transparent />
          <Row justify="center">
            <Col align="center">
              <Button primary onClick={handlePreviousStep}>
                Previous
              </Button>
              <TermsAndConditionsButton
                tertiary
                onClick={handleNextClick(nextStep)}
                disabled={!hasAgreedTcpa || !hasAgreedPrivacy || !hasAgreedInfo}
                loading={loading}
              >
                Next
              </TermsAndConditionsButton>
            </Col>
          </Row>
        </TermsAndConditionsContainer>
        {modalIsOpen && (
          <TermsAndConditionsModal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseModal}
            currentTermsType={currentTermsType}
          />
        )}
      </>
    </PanelLayout>
  );
};

export default TermsAndConditionsVerde;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditionsVerde.tsx